import { createFileRoute, getRouteApi, Navigate, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_management/verkehrszeichen/$adminLevelId')({
  component: () => {
    const route = getRouteApi('/_authenticated/_management/verkehrszeichen/$adminLevelId');
    const { adminLevelId } = route.useParams();

    if (adminLevelId === 'undefined') return <Navigate to="/verkehrszeichen/recherche" />;

    return <Outlet />;
  },
});
